import gql from 'graphql-tag';

export default gql`
  mutation RemoveLipidProfileMeasurementMutation($request: LipidProfileTestRemoveInputType!) {
    diabetes {
      lipidTestRemove(testRemoveData: $request) {
        __typename
        ... on BasicMutationSuccess {
          successCode: code
        }
        ... on UnauthorizedException {
          unauthorizedCode: code
        }
        ... on ValidationException {
          validationCode: code
          messages
          details {
            fieldName
            messages
          }
        }
        ... on Error {
          errorCode: code
          name
          description
        }
      }
    }
  }
`;
